<div fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="center" class="pt-24 pb-24">
  <button [attr.data-test-id]="'cancel-filter-button'" mat-raised-button (click)="resetFilter()">
    {{ "PR.STP.COMP.CLEAN_FILTER_BTN" | pTranslate }}
  </button>
  <button
    [attr.data-test-id]="'apply-filter-button'"
    [disabled]="disabled || hasErrors"
    mat-raised-button
    color="accent"
    (click)="applyFilter()"
  >
    {{ "PR.STP.COMP.APPLY_FILTER_BTN" | pTranslate }}
  </button>
</div>
